import React from "react";
import HeroSection from "../components/ContactUs/HeroSection";
import JoinWithUsForm from "../components/ContactUs/JoinWithUsForm";
import ContactDetailsSection from "../components/ContactUs/ContactDetailsSection";
//import MapSection from "../components/ContactUs/MapSection";

const ContactUs = () => {
  return (
    <>
      <HeroSection />
      <JoinWithUsForm />
      <ContactDetailsSection />
      {/* <MapSection /> */}
    </>
  );
};

export default ContactUs;
